module.exports = __webpack_public_path__ + "static/media/person-accent.53a81eda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/person-accent.svg
// module id = 200
// module chunks = 0